"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _colors = require("@material-ui/core/colors");

var _greyscale = _interopRequireDefault(require("./greyscale"));

var background = {
  "default": _greyscale["default"][50],
  paper: _colors.common.white
};
var _default = background;
exports["default"] = _default;